import { useEffect, useState } from "react";
import { fetchBalanceAdjustmentData } from "../Api/ViewBalanceAdjustment";
import { Container, Table } from "react-bootstrap";
//import "../Styling/ViewBalanceAdjustment.css";
import { toast } from "react-toastify";
import moment from "moment";

const ViewBalanceAdjustmentAdvanceReq = () => {
  const [adjustments, setAdjustments] = useState([]);

  useEffect(() => {
    const loadAdjustments = async () => {
      try {
        const data = await fetchBalanceAdjustmentData();
        setAdjustments(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Balance Adjustments`);
      }
    };

    loadAdjustments();
  }, []);

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">View Balance Adjustments</span>

          {adjustments.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Balance Adjustment ID</th>
                      <th>Employee Name</th>
                      <th>Total Advance Amount</th>
                      <th>Total Actual Expenses</th>
                      <th>Balance Amount</th>
                      <th>Adjustment Type</th>
                      <th>Adjustment Date</th>
                      <th>Adjustment Mode</th>
                      <th>Approved By</th>
                      <th>Remarks</th>
                      <th>Created At</th>
                      <th>Created By</th>
                      <th>Advance Request ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {adjustments.map((adjustment, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{adjustment.balanceAdjustmentId}</td>
                        <td>{adjustment.employeeName}</td>
                        <td>{adjustment.totalAdvanceAmountDisbursed}</td>
                        <td>{adjustment.totalActualExpenses}</td>
                        <td>{adjustment.balanceAmount}</td>
                        <td>{adjustment.adjustmentType}</td>
                        <td>{new Date(adjustment.adjustmentDate).toLocaleDateString()}</td>
                        <td>{adjustment.adjustmentMode}</td>
                        <td>{adjustment.approvedBy}</td>
                        <td>{adjustment.remarks}</td>
                        <td>{moment(adjustment.createdAt).format('L')}</td>
                        <td>{adjustment.createdBy}</td>
                        <td>{adjustment.advanceReqId}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No balance adjustments found.</p>
          )}
        </Container>
      </div>
  );
};

export default ViewBalanceAdjustmentAdvanceReq;